import Resource from '@/plugins/sdk/Resource'
import { DATETIME, STRING, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import NotificationTemplate from '@/plugins/sdk/resources/NotificationTemplate'

export default class extends Resource {
  static name = 'notificationtemplatetype'

  static get fields () {
    return {
      id: new UUID(),
      template: new STRING(),
      description: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      templates: new COLLECTION(NotificationTemplate),
      default_template: new ITEM(NotificationTemplate)
    }
  }
}
